import React from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Container, Image } from 'react-bootstrap';
import { Helmet } from 'react-helmet';

class Thanks extends React.Component {

    render() {
        return (
            <>
                <Helmet>
                    <title>Vielen Dank für Ihre Bestellung. Bestellen Sie leckeres Essen mit Liefershops.de</title>
                    <meta name="description" content="Sichere und einfache Zahlungsmöglichkeiten für Ihre Bestellungen. Bestellen Sie bequem online und lassen Sie sich Ihre Gerichte direkt nach Hause liefern mit Liefershops.de" />
                    <meta name="keywords" content="Online bezahlen, sichere Zahlung, Zahlungsmethoden, Bar, PayPal, schnelle Bestellung, Essenslieferung in Berlin" />
                    <meta property="og:title" content="Essen bestellen sicher und schnell mit Liefershops.de in Berlin" />
                    <meta property="og:description" content="Nutzen Sie einfache und sichere Zahlungsmethoden für Ihre Bestellung. Bestellen Sie bequem online und lassen Sie sich Ihre Gerichte direkt nach Hause liefern mit Liefershops.de" />
                    <meta property="og:type" content="website" />
                    <meta name="robots" content="index, follow" />
                </Helmet>
                <section className="section pt-5 pb-5 osahan-not-found-page">
                    <Container>
                        <Row>
                            <Col md={12} className="text-center pt-5 pb-5">
                                <Image className="img-fluid" src="/img/thanks.png" alt="404" />
                                <h1 className="mt-2 mb-2">Glückwunsch</h1>
                                <p className="mb-5">Sie haben Ihre Bestellung erfolgreich aufgegeben</p>
                                <Link className="btn btn-primary btn-lg" to="/">HOME</Link>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </>
        );
    }
}


export default Thanks;